module.exports = {"430525001":"文昌街道","430525002":"雪峰街道","430525003":"花古街道","430525101":"江口镇","430525102":"毓兰镇","430525103":"高沙镇","430525104":"竹市镇","430525105":"石江镇","430525106":"黄桥镇","430525107":"山门镇","430525108":"醪田镇","430525109":"花园镇","430525110":"岩山镇","430525111":"水东镇","430525112":"杨林镇","430525113":"月溪镇","430525114":"石柱镇","430525201":"古楼乡","430525202":"长塘瑶族乡","430525203":"罗溪瑶族乡","430525205":"渣坪乡","430525211":"桐山乡","430525212":"大屋瑶族乡","430525500":"茶铺茶场管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430525.json
// module id = 1979
// module chunks = 0